import React from "react";
import { StyleSheet, View } from "@react-pdf/renderer";
import {
  ContractInfoValueText,
  formatContractInfoValue,
  formatProfitabilityAmount,
  getProfitabilityUnitLabel,
} from "./ContractInfoPdfLayout";

interface ProfitabilityFieldProps {
  field?: {
    category?: string;
    amount?: number | string | null;
    note?: string | null;
  };
  borderBottom?: boolean;
  hideCategory?: boolean;
  unit?: string;
}

const styles = StyleSheet.create({
  row: {
    width: "100%",
    minHeight: "5.2mm",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  categoryWrap: {
    width: "15mm",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  category: {
    fontWeight: 600,
  },
  amountWrap: {
    width: "23mm",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  amount: {
    width: "100%",
    textAlign: "right",
  },
  unitWrap: {
    width: "8mm",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  noteWrap: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: "0.5mm",
    overflow: "hidden",
  },
});

const ProfitabilityField = ({
  field,
  borderBottom,
  hideCategory,
  unit = "1",
}: ProfitabilityFieldProps) => {
  return (
    <View
      style={[
        styles.row,
        {
          borderBottom: borderBottom ? "0.2mm solid #C6C8CD" : undefined,
        },
      ]}
    >
      <View style={styles.categoryWrap}>
        {!hideCategory && (
          <ContractInfoValueText style={styles.category}>
            {formatContractInfoValue(field?.category)}
          </ContractInfoValueText>
        )}
      </View>
      <View style={styles.amountWrap}>
        <ContractInfoValueText style={styles.amount}>
          {formatProfitabilityAmount(field?.amount, unit)}
        </ContractInfoValueText>
      </View>
      <View style={styles.unitWrap}>
        <ContractInfoValueText>
          {getProfitabilityUnitLabel(unit)}
        </ContractInfoValueText>
      </View>
      <View style={styles.noteWrap}>
        <ContractInfoValueText
          wrap={false}
          hyphenationCallback={(word) => [word]}
        >
          {formatContractInfoValue(field?.note)}
        </ContractInfoValueText>
      </View>
    </View>
  );
};

export default ProfitabilityField;
